import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { MobileButton, MobileHighlightPage } from "../../../components";

import { localStorageCleanup } from "../../../services/util.service";

import useStyles from "./SaveResult.style";
import Cookies from 'universal-cookie';


const cookies = new Cookies();

const SaveResult = props => {
    const classes = useStyles();

    const [saving, setSaving] = useState(true);
    const [success, setSuccess] = useState();

    const { t } = useTranslation();

    const postParams = () => {
        let params = new URLSearchParams();

        let dateOfBirth = localStorage.getItem('dateOfBirth');
        let firstMenstruationAge = localStorage.getItem('firstMenstruationAge');
        let sexualDebutAge = localStorage.getItem('sexualDebutAge');
        let childbearingYearFrame = localStorage.getItem('childbearingYearFrame');
        let menopauseAge = localStorage.getItem('menopauseAge');
        let pregnancyData = localStorage.getItem('pregnancies');
        let adoptionData = localStorage.getItem('adoptions');
        let stepchildrenData = localStorage.getItem('stepchildren');
        let childrenDeathData = localStorage.getItem('childrenDeath');
        let sexualPreference = localStorage.getItem('sexualPreference');
        let relationshipStatus = localStorage.getItem('relationshipStatus');
        let contraceptiveMethods = localStorage.getItem('contraceptiveMethods');
        let fertilityPreservationMethods = localStorage.getItem('fertilityPreservationMethods');
        let fertilityTreatments = localStorage.getItem('fertilityTreatments');
        let cancerDiagnosis = localStorage.getItem('cancerDiagnosis');
        let cancerTreatments = localStorage.getItem('cancerTreatments');

        if (dateOfBirth) params.append('dateOfBirth', dateOfBirth);
        if (firstMenstruationAge || firstMenstruationAge === 0)
            params.append('firstMenstruationYear', firstMenstruationAge);
        if (sexualDebutAge || sexualDebutAge === 0)
            params.append('sexualDebutYear', sexualDebutAge);
        if (childbearingYearFrame) params.append('childbearingYearFrame', childbearingYearFrame);
        if (menopauseAge) params.append('menopauseYear', menopauseAge);
        if (pregnancyData) params.append('pregnancies', pregnancyData);
        if (adoptionData) params.append('adoptions', adoptionData);
        if (stepchildrenData) params.append('stepchildren', stepchildrenData);
        if (childrenDeathData) params.append('childrenDeath', childrenDeathData);
        if (sexualPreference) params.append('sexualPreference', sexualPreference);
        if (relationshipStatus) params.append('relationshipStatus', relationshipStatus);
        if (contraceptiveMethods) params.append('contraceptiveMethods', contraceptiveMethods);
        if (fertilityPreservationMethods) params.append('fertilityPreservationMethods', fertilityPreservationMethods);
        if (fertilityTreatments) params.append('fertilityTreatments', fertilityTreatments);
        if (cancerDiagnosis) params.append('cancerDiagnosis', cancerDiagnosis);
        if (cancerTreatments) params.append('cancerTreatments', cancerTreatments);

        return params;
    }

    useEffect(() => {
        const saveRepLIQuestionnaire = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`, {
                    method: 'post',
                    body: postParams(),
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (response.ok) localStorageCleanup();
                setSuccess(response.ok);
            } catch (error) {
                console.log(error);
                setSuccess(false);
            } finally {
                setSaving(false);
            }
        };

        saveRepLIQuestionnaire();
    }, []);

    const SavingResultComponent = props => {
        if (props.success === undefined) return null;
        if (!props.success) return (
            <Box className={classes.savingInfo}>
                {t('repliQuestionnaire.saving.failure')}
            </Box>
        );
        return (
            <Box className={classes.savingInfo}>
                {t('repliQuestionnaire.saving.success')}
            </Box>
        );
    }

    return (
        <MobileHighlightPage>
            <Box className={classes.title}>
                <Typography variant="h4">
                    {t('repliQuestionnaire.saving.title')}
                </Typography>
            </Box>
            <Box className={classes.infoText}>
                {t('repliQuestionnaire.saving.info')}
            </Box>
            {
                saving &&
                <Box className={classes.savingInfo}>
                    {t('repliQuestionnaire.saving.pending')}&nbsp;&nbsp;&nbsp;&nbsp;
                    <CircularProgress color="inherit" />
                </Box>
            }
            <SavingResultComponent success={success} />
            <Box className={classes.footer}>
                <MobileButton label={t('repliQuestionnaire.saving.buttonLabel')} component={Link} to="/app/repli/send" />
            </Box>
        </MobileHighlightPage >
    );
};

export default SaveResult;